var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"mb-1 list-none dropdown-menu__item",class:{
    'is-disabled': _vm.disabled,
  },attrs:{"tabindex":_vm.disabled ? null : -1,"aria-disabled":_vm.disabled}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }